export enum ErrorType {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  ALREADY_LINKED = 'ALREADY_LINKED',
  AVATAR_UPLOAD_ERROR = 'Image_Upload_Error',
  CHECKLIST_ALREADY_IN_USE = 'CHECKLIST_ALREADY_IN_USE',
  CLIENT_LIMIT_EXCEEDED = 'CLIENT_LIMIT_EXCEEDED',
  DATE_IN_PAST = 'DATE_IN_PAST',
  RANGE_IN_PAST = 'RANGE_IN_PAST',
  EMAIL_ALREADY_REGISTERED = 'EMAIL_ALREADY_REGISTERED',
  EMAIL_NOT_VALID = 'EMAIL_NOT_VALID',
  INVALID_EMAIL = 'Invalid email',
  INVALID_TIME = 'INVALID_TIME',
  INCOMPLETE = 'INCOMPLETE',
  IDENTIFIER_ALREADY_EXISTS = 'IDENTIFIER_ALREADY_EXISTS',
  NAME_ALREADY_EXISTS = 'NAME_ALREADY_EXISTS',
  NAME_IS_MANDATORY = 'NAME_IS_MANDATORY',
  NOT_EXISTS = 'NOT_EXISTS',
  NO_PERMISSION = 'NO_PERMISSION',
  NOT_VALID = 'NOT_VALID',
  ACCOUNT_DISABLED = 'ACCOUNT_DISABLED',
  IS_REQUIRED = 'IS_REQUIRED',
  UNKNOWN = 'Unknown',
  NO_AVAILABLE_APPOINTMENT_SLOT = 'NO_AVAILABLE_APPOINTMENT_SLOT',
  TIMEOUT = 'TIMEOUT'
}

export enum ERROR_IMPORT_TYPES {
  CLIENT_NAME_REQUIRED = 'CLIENT_NAME_REQUIRED',
  CLIENT_NAME_EXISTS = 'CLIENT_NAME_EXISTS',
  CLIENT_IN_DIFFERENT_INVENTORY = 'CLIENT_IN_DIFFERENT_INVENTORY',
  CLIENT_NAME_MORE_THEN_ONCE = 'CLIENT_NAME_MORE_THEN_ONCE',
  STATUS_NOT_EXISTS = 'STATUS_NOT_EXISTS',
  ASSIGNEE_NOT_EXISTS = 'ASSIGNEE_NOT_EXISTS',
  CLIENT_USER_NOT_EXISTS = 'CLIENT_USER_NOT_EXISTS',
  OPTION_NOT_EXISTS = 'OPTION_NOT_EXISTS',
  CLIENT_GROUP_NOT_EXISTS = 'CLIENT_GROUP_NOT_EXISTS',
  CLIENT_NOT_EXISTS = 'CLIENT_NOT_EXISTS',
  ADVANCED_CUSTOM_FIELD_VALUE_NOT_MATCHING = 'ADVANCED_CUSTOM_FIELD_VALUE_NOT_MATCHING',
  UNKNOWN = 'UNKNOWN',
}

